// extracted by mini-css-extract-plugin
module.exports = {"extraLargeBreakpoint":"1900px","largeBreakpoint":"1450px","mediumLargeBreakpoint":"1200px","mediumSmallBreakpoint":"850px","mediumBreakpoint":"1000px","smallBreakpoint":"700px"};